import styled from 'styled-components';
import {lightenColor} from 'components/customer/Confirmation/helpers/lightenColor';
import {mobile, size} from 'shared/Breakpoints';

export const Table = styled.table`
    width: calc(100% - 35px);
    margin-left: 35px;

    ${mobile`
        width: 100%;
        margin-left: 0;
    `};

    > thead > tr > th {
        background: ${({theme}) => theme.colors.secondary.main};
        color: white;
        text-align: center;

        &:first-child {
            border-radius: 10px 0 0 0;
        }

        &:last-child {
            border-radius: 0 0 10px 0;
        }
    }
`;

export const Row = styled.tr`
    &:nth-child(even) {
        > td {
            background: ${({theme}) =>
                lightenColor(theme.colors.secondary.main, 95)};
        }
    }

    > td {
        padding: 5px;
        text-align: center;

        &:first-child {
            text-align: left;
            padding-left: 30px;

            font-weight: bold;
            color: ${({theme}) => theme.colors.primary.main};
        }

        &:nth-child(2) {
            color: #6b6969;
        }

        &:nth-child(even) {
            background: ${({theme}) =>
                lightenColor(theme.colors.secondary.main, 92)};
        }

        &:first-child {
            ${mobile`
                padding-left: 0;
                font-size: 0.80em;    
            `}
        }
    }

    border-bottom: 1px solid
        ${({theme}) => lightenColor(theme.colors.secondary.main, 60)};
`;

export const BoldSecondaryText = styled.div`
    color: ${({theme}) => theme.colors.secondary.main};
    font-weight: bold;
`;

export const ActionContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;

    > img {
        width: 25px;
        cursor: pointer;
    }
`;

export const ItemContainer = styled.div`
    display: flex;

    ${mobile`
        justify-content: space-between;
    `}
`;

export const VariationItemContainer = styled(ItemContainer)<{
    $isDeleted?: boolean;
}>`
    margin-left: 50px;

    > div {
        font-weight: 500;
        color: #3f3f3f;
        font-size: 0.85em;
    }

    ${({$isDeleted}) => {
        if ($isDeleted) {
            return `opacity: 0.5`;
        }
    }}
`;

export const VariationPriceContainer = styled.div`
    font-size: 0.85em;
`;

export const Item = styled.div`
    display: flex;
    min-width: 200px;

    > div {
        min-width: 160px;
    }

    ${mobile`
        min-width: initial;

        > div {
            min-width: initial;
        }
    `}
`;

export const TotalRow = styled.tr`
    > td:not(:first-child) {
        background: ${({theme}) => theme.colors.primary.main};

        ${mobile`
            padding: 5px 0;
        `}
    }

    > td:nth-child(2) {
        border-radius: 0 0 0 20px;

        ${mobile`
            border-radius: 0 0 0 5px;
        `}
    }

    > td:nth-child(3) {
        border-radius: 0 0 20px 0;
    }
`;

export const TotalCost = styled.div`
    padding: 0 30px;
    text-align: right;
    color: ${({theme}) => theme.colors.secondary.main};
    font-weight: 900;
    font-size: 1.8em;
    text-transform: uppercase;

    ${mobile`
        text-align: left;
        padding: 0;
        font-size: 1em;    
    `}
`;

export const CostFigure = styled.div<{$em?: boolean}>`
    font-weight: ${({$em = true}) => ($em ? '900' : '400')};
    font-size: ${({$em = true}) => ($em ? '1.6em' : '1em')};
    text-align: center;
    color: white;

    @media (max-width: ${size.sm - 1}px) {
        font-size: ${({$em = true}) => ($em ? '1em' : '0.8em')};
    }
`;
